const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
    sides: {
        top: false,
        left: false,
        bottom: false,
        right: false,
    },
    i18n: 'en'
}

const funSlice = createSlice({
    name: "fun",
    initialState,
    reducers: {
        toggleSibar: (state, action) => {
            // state.sides.push(action.payload.anchor : action.payload.open) 
            // { ...state.sides, action.payload.anchor open }
            if(action.payload.anchor === 'top'){
                state.sides.top = action.payload.open
            }
            if(action.payload.anchor === 'left'){
                state.sides.left = action.payload.open
            }
            if(action.payload.anchor === 'bottom'){
                state.sides.bottom = action.payload.open
            }
            if(action.payload.anchor === 'right'){
                state.sides.right = action.payload.open
            }
        },
        toggleI18n: (state, action) => {
            state.i18n = action.payload;
        }
    },
});

export default funSlice.reducer;
export const { toggleSibar, toggleI18n } = funSlice.actions;